import {TransactionChargeSettingsRepository} from "../../domain/types";
import {ChargeSettingsRepositoryV2} from "./repository.v2";

export type {TransactionChargeSettingsRepository} from "../../domain/types";

/**
 * Creates the ChargeSettingsRepository.
 *
 * v1 has been decommissioned; v2 is the only implementation.
 *
 * @example
 * const repository = createChargeSettingsRepository();
 * const settings = await repository.getSettings();
 */
export const createChargeSettingsRepository = (): TransactionChargeSettingsRepository => {
  return new ChargeSettingsRepositoryV2();
};
